<template>
  <div v-if="category">
    <div :class="getItemClasses">
      <div v-if="category.categories && category.categories.length && displayChildren" class="d-flex align-items-center mr-2" @click="onChevronClick">
        <ci-awesome-icon ref="chevron" :class="getIconClasses" icon="chevron-right" ratio="0.5" />
      </div>
      <div class="d-block" v-if="!small">
        <div>
          <strong>
            {{ category.title }} <span v-if="category.categories && category.categories.length">({{ category.categories.length }})</span>
          </strong>
        </div>
        <div>
          <span class="text-small text-muted">{{ category.created_at | date }}</span>
        </div>
      </div>

      <span class="text-small ml-2" v-if="small">{{ category.title }}</span>

      <div class="ml-auto controls d-flex align-items-center" v-if="!selectable">
        <ci-item-actions :actions="getItemActions" @click="onActionClick"/>
      </div>
      <div :class="getCheckIconClasses" v-if="selectable && parentSelectable" @click="onCheckClick()">
        <ci-awesome-icon icon="check" ratio="0.75" />
      </div>
    </div>

    <div v-if="category.categories && category.categories.length && uncollapsed && displayChildren">
      <category-item
        class="ml-4"
        v-for="category in category.categories"
        :key="`category-${category.id}`"
        :small="small"
        :selectable="selectable"
        :selected-categories="selectedCategories"
        :category="category"
        :parent-selectable="true"
        @category-item:selected="onChildSelected"
        @category-item:delete="onDeleteItem" />
    </div>
  </div>
</template>

<script>
// components
import AwesomeIcon from '@/components/AwesomeIcon.vue';
import ItemActions from '@/components/ItemActions.vue';

// libs
import moment from 'moment';

export default {
  name: 'CategoryItem',

  components: {
    'ci-awesome-icon': AwesomeIcon,
    'ci-item-actions': ItemActions,
  },

  props: {
    category: {
      type: Object,
      required: true,
    },

    displayChildren: {
      type: Boolean,
      required: false,
      default: true,
    },

    parentSelectable: {
      type: Boolean,
      required: false,
      default: false,
    },

    selectable: {
      type: Boolean,
      required: false,
      default: false,
    },

    selectedCategories: {
      type: Array,
      required: false,
    },

    singleSelect: {
      type: Boolean,
      required: false,
      default: false,
    },

    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      uncollapsed: false,
    };
  },

  computed: {
    getCheckIconClasses() {
      return {
        'ml-auto': true,
        'd-flex': true,
        'align-items-center': true,
        'icon-muted': !this.isSelected,
        'icon-link': true,
        'icon-primary': this.isSelected,
      };
    },

    getIconClasses() {
      return {
        'icon-rotateable': true,
        'icon-uncollapsed': this.uncollapsed,
      };
    },

    getItemActions() {
      return [
        {
          icon: 'pen',
          type: 'edit',
        },
        {
          icon: 'trash',
          type: 'delete',
        },
      ];
    },

    getItemClasses() {
      return {
        'p-1': this.small,
        'p-3': !this.small,
        'mt-2': true,
        'bg-white': !this.small,
        'bg-light': this.small,
        'd-flex': true,
        'align-items-center': this.small,
      };
    },

    isSelected() {
      // eslint-disable-next-line
      const filteredCategory = this.selectedCategories.filter(category => category.id === this.category.id);
      if (filteredCategory.length) {
        return true;
      }

      return false;
    },
  },

  methods: {
    onCheckClick() {
      this.$emit('category-item:selected', {
        item: this.category,
        selected: !this.isSelected,
      });
    },

    onChildSelected(payload) {
      if (this.singleSelect) {
        this.$emit('category-item:selected', {
          item: payload.item,
          parent: this.category,
          selected: true,
        });
      } else {
        this.$emit('category-item:selected', {
          item: payload.item,
          parent: this.category,
          selected: payload.selected,
        });

        if (payload.selected && !this.isSelected) {
          this.$emit('category-item:selected', {
            item: this.category,
            parent: this.category,
            selected: !this.isSelected,
          });
        }
      }
    },

    onChevronClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.uncollapsed = !this.uncollapsed;
    },

    onDeleteItem(categoryId) {
      this.$emit('category-item:delete', categoryId);
    },

    onEditClick() {
      const { id } = this.category;
      this.$router.push({ path: `/categories/edit/${id}` });
    },

    onActionClick(type) {
      switch (type) {
        case 'edit': {
          const { id } = this.category;
          this.$router.push({ path: `/categories/edit/${id}` });
          break;
        }

        case 'delete': {
          const { id } = this.category;
          this.$emit('category-item:delete', id);
          break;
        }

        default: {
          break;
        }
      }
    },
  },

  filters: {
    date(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('DD.MM.YYYY | HH:MM:ss');
    },
  },
};
</script>
